var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrapper"},[_c('v-img',{attrs:{"src":require("../../assets/philips_shape_digital_98x51.svg")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }